/*global $:false, screen:false, Modernizr:false, __:false, routeMatcher:false, location:false, _ */

;(function () {
    "use strict";

    var params = {
        root: '.layout',
        showLoadingAfter: 0,
        closeByEscape: true,
        loadDataUrl: '/video/data/',
        delegateTo: '.js-overlay-media',
        selector: 'a[data-type="video"], button[data-type="video"]'
    };

    var modalId = 'modal_video';

    $(document).on('ready VideoOverlay::bind', function() {
        // bind
        var $modal = $('#' + modalId);
        var $videoCode = $modal.find('.modal-video__code');
        var $videoLoader = $modal.find('.modal-video__loader');
        var $closeModal = $modal.find('.modall__close');
        var opened = false;

        $(params.delegateTo).off('click.VideoOverlay');
        $(params.delegateTo).on('click.VideoOverlay', params.selector, function (e) {
            var isNotPrimaryMouseButton = 'undefined' !== typeof e.which && 1 !== e.which;
            if (isNotPrimaryMouseButton) {
                return;
            }

            $videoLoader.removeClass('modal-video__loader_hidden');
            $closeModal.hide();

            e.preventDefault();

            var $this = $(this);
            var id = $(this).data('id');
            window.Modal.openModal(modalId);
            opened = true;

            $.ajax({
                       data: {
                           id: id
                       },
                       cache: false,
                       url: params.loadDataUrl,
                       type: 'POST'
                   })
                .done(function(data) {
                    if (!opened) {
                        return;
                    }
                    var code = data.code;
                    $closeModal.show();
                    $videoCode.html(code);
                    $modal.find('.fit-vid').fitVids();
                })
                .fail(function(){
                    if (!opened) {
                        return;
                    }
                    Toasts.pushToast('Произошла ошибка загрузки видео. Попробуйте повторить попытку', 'fail');
                    window.Modal.closeModal(modalId);
                })
                .always(function() {
                    $videoLoader.addClass('modal-video__loader_hidden');
                })

        });

        $(document).on('Modal::close', function(event, modal) {
            if (modal.prop('id') != modalId) {
                return;
            }

            $videoCode.html('');
            opened = false;

        });
    });

})();
